module.exports = __webpack_public_path__ + "media/post-listing-block-2-overlay-wide.a62d84bf.png";